import {background} from "./ImageRightsRecords";

<template>
	<div>

		<b-modal ref="emptyId"
			hide-footer
			title="Erreur">
			<p class="my-4">{{ this.inputsError }}</p>
		</b-modal>

		<div id="content">
			<form @submit.prevent="connexion" method="post" class="cell">
				<p>{{ $t("login") }}</p>
				<span class="sr-only"><label for="input_email">Adresse email / Email address</label> :</span>
				<input name="email" id="input_email" type="email" :placeholder="$t('form_placeholders.email_address')" v-model="input.email" />
				<br /> <span class="sr-only"><label for="input_password">Password</label> :</span>
				<input name="password" id="input_password" type="password" :placeholder="$t('form_placeholders.password')" v-model="input.password" />
				<br />
				<a href="https://horoquartz.enjoyb.net/py/reset" class="forgotten">{{  $t("form_placeholders.forgotten_password") }}</a><br />
				<input type="submit" :value="$t('login')" class="button" />
			</form>

			<div v-if="false" id="create" class="cell">
				<p>Obtenir l'application iOS / Obtain the iOS app</p>

				<b-button class="button" href="https://horoquartz.enjoyb.net/py/auth/register">Créer un compte</b-button>
				<br /> <span style="font-size:10px; font-style: italic;">Add an account</span>

				<b-button class="button" href="https://horoquartz.enjoyb.net/py/">Associer un téléphone à un compte</b-button>
				<br /> <span style="font-size:10px; font-style: italic;">Add a phone to an account</span>
			</div>

		</div>
	</div>
</template>

<script>
import axios from "axios";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "Login",
	data() {
		return {
			input: {
				email: "",
				password: "",
			},
			inputsError: "",
		};
	},
	methods: {
		connexion() {
			if (this.input.email !== "" && this.input.password !== "") {
				let $this = this;
				let bodyFormData = new FormData();
				if ($this.input.email.length > 0) {
					bodyFormData.append("email", $this.input.email);
				}
				if ($this.input.password.length > 0) {
					bodyFormData.append("password", $this.input.password);
				}
				axios.post(BASE_URL + "/public/api/login",
					bodyFormData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
							"Authorization": sessionStorage.getItem("auth"),
						},
					},
				).catch(function(error) {
					if (error.response.status === 401) {
						$this.inputsError = "L'identifiant et le mot de passe ne correspondent pas. Veuillez recommencer";
						$this.$refs.emptyId.show();
					}
				}).then(async response => {
					if (typeof response !== "undefined") {
						let data = response.data;
						if (response.status === 200) {
							sessionStorage.setItem("isConnected", true);
							sessionStorage.setItem("username", data.user.name);
							sessionStorage.setItem("usermail", data.user.email_address);
							sessionStorage.setItem("auth", data.auth);
							await new Promise(resolve => setTimeout(resolve, 250));
							$this.$router.push({name: "Dashboard"});
						}
						else if (response.status === 401) {
							this.inputsError = "Identifiant ou mot de passe invalide.";
							this.$refs.emptyId.show();
						}
						else {
							this.inputsError = "Impossible de se connecter au serveur.";
							this.$refs.emptyId.show();
						}
					}
					else {
						this.inputsError = "Impossible de se connecter au serveur.";
						this.$refs.emptyId.show();
					}
				});
			}
			else {
				this.inputsError = "L'identifiant et le mot de passe ne peuvent pas être vides. Veuillez recommencer...";
				this.$refs.emptyId.show();
			}
		},
	},
};
</script>

<style scoped>
.navbar-class {
	background-color: transparent;
	position: absolute;
	right: 0;
}

#button_create {
	position: fixed;
	bottom: 0;
	right: 0;
	margin: 15px;
	background: var(--color-validation);
}

#content {
	padding: 100px 0 0;
	display: grid;
	grid-template-columns: 1fr;
	grid-column-gap: 36px;
	margin: 0 auto;
	width: 742px;
}

.cell {
	margin: 0 auto 0;
	width: 353px;
	font-family: Arial Regular, Arial, sans-serif;
	font-size: 16px;
	color: var(--text-main);
	border-radius: 10px;
	box-shadow: 0 0 15px #00000033;
	background: #F7F7F7;
	padding: 21px 15px 14px;
}

@media screen and (max-width: 800px) {
	#content {
		padding: 192px 0 0;
		display: grid;
		grid-template-columns: 1fr;
		width: auto;
	}

	.cell {
		margin: 0 auto 50px;
	}
}

form {
	background: #FFFFFF;
	margin: 0 auto;
}

form p {
	margin: 0 0 24px;
}

input {
	height: 15px;
	box-sizing: content-box;
	border-radius: 5px;
	font-size: 16px;
}

input[type="submit"] {
	height: 38px;
}

#create {
	text-align: center;
}

#input_email,
#input_password {
	padding: 11px 12px 10px;
	margin-bottom: 9px;
	border: 1px solid #8AA0B2;
	width: 297px;
}

#input_password {
	margin-bottom: 0;
}

.button {
	box-sizing: border-box;
	font-size: 16px;
	background: var(--color-main-action);
	border: none;
	border-radius: 5px;
	color: #FFFFFF;
	margin: 9px 0 0;
}

.forgotten {
	margin: 0;
	font-size: 9px;
	color: #8AA0B2;
}
</style>
